import Swal from "sweetalert2/dist/sweetalert2.js";
import Load from "../images/loading.svg";

class Alert {
  showLoading() {
    Swal.fire({
      title: "",
      customClass: "swal-loading",
      html: `<img src="${Load}" width="90px" height="90px" /> `,
      icon: "",
      showConfirmButton: false,
      allowOutsideClick: true,
    });
  }

  hideLoading() {
    Swal.close();
  }

  alertWithTitle(title, msg, icon) {
    Swal.fire({
      title: title,
      text: msg,
      icon
    });
  }

  alertWithHTML(title, msg, icon) {
    Swal.fire({
      title: title,
      html: msg,
      icon
    });
  }

  alertSuccess(msg) {
    Swal.fire({
      text: msg,
      icon: "success"
    });
  }

  async alertMessage(
    title,
    msg,
    icon,
    ConfirmButton,
    ConfirmText,
    CancelButton,
    CancelText
  ) {
    return Swal.fire({
      title: title,
      text: msg,
      icon,
      showCloseButton: ConfirmButton,
      confirmButtonText: ConfirmText,
      cancelButtonColor: "#3bb2e8",
      showCancelButton: CancelButton,
      cancelButtonText: CancelText,
      cancelButtonColor: "#ffffff"
    }).then(result => {
      if (result.value === true) {
        return "option1"; // step3
      } else if (result.dismiss === "cancel") {
        return "option2"; // step2
      }
    });
  }

  async alertMessageWith3Button(
    title,
    msg,
    icon,
    ConfirmButton,
    ConfirmText,
    CancelButton,
    CancelText,
    handleClickClose
  ) {
    if (handleClickClose) {
      window.clickClose = handleClickClose;
    } else {
      window.clickClose = this.hideLoading;
    }

    return Swal.fire({
      title: title,
      html: msg,
      icon,
      showCloseButton: ConfirmButton,
      confirmButtonText: ConfirmText,
      cancelButtonColor: "#3bb2e8",
      showCancelButton: CancelButton,
      cancelButtonText: CancelText,
      cancelButtonColor: "#ffffff",
      cancelButtonClass: "custom-swal2-cancel",
      footer: '<button type="button" class="swal2-cancel btn btn-outline-primary swal2-styled border-0" aria-label="" style="display: inline-block; background-color: rgb(255, 255, 255); color: black;" onclick="window.clickClose()">ยกเลิก</button>'
    }).then(result => {
      if (result.value === true) {
        return "option1"; // step3
      } else if (result.dismiss === "cancel") {
        return window.location = 'https://www.mticonnect.com/Contact/Comment' // step2
      }
    })
  }
}

export default new Alert();
